<template>
    <div>
        <header-page/>
    </div>
</template>

<script>
import HeaderPage from '../HeaderPage.vue'
export default {
  components: { HeaderPage },
    
}
</script>